import { Vector3 } from "three";
var TOL = 1e-5;
var closestPoint = new Vector3();
var midPoint = new Vector3();
function isLineOnEdges(line, edges) {
	if (!edges) return false;
	line.getCenter(midPoint);
	for (const edge of edges) {
		edge.closestPointToPoint(midPoint, true, closestPoint);
		if (closestPoint.distanceToSquared(midPoint) < TOL) return true;
	}
	return false;
}
export { isLineOnEdges };

//# sourceMappingURL=index61.js.map